
import React from 'react';
import { Droppable, Draggable, DroppableProvided, DraggableProvided } from 'react-beautiful-dnd';
import { Task } from '@/context/TaskContext';
import { cn } from '@/lib/utils';

interface EisenhowerQuadrantColumnProps {
  id: string;
  label: string;
  icon: string;
  tasks: Task[];
  provided: DroppableProvided;
  innerRef: (element: HTMLElement | null) => any;
  handleDragStart: (task: Task) => void;
}

export const EisenhowerQuadrantColumn: React.FC<EisenhowerQuadrantColumnProps> = ({
  id, label, icon, tasks, provided, innerRef, handleDragStart
}) => (
  <div
    ref={innerRef}
    className="relative p-3 min-h-[160px] border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-lg flex flex-col"
    {...provided.droppableProps}
  >
    <div className="mb-2 flex gap-2 items-center font-bold text-xs text-gray-900 dark:text-white">
      <span className="text-lg">{icon}</span>
      {label}
      <span className="ml-auto text-[10px] text-gray-400 font-normal">{tasks.length}</span>
    </div>
    <div className="flex-1">
      {tasks.length === 0 && (
        <div className="absolute inset-0 top-10 border-2 border-dashed border-gray-200 dark:border-gray-700 rounded flex items-center justify-center pointer-events-none">
          <span className="text-xs text-gray-400 dark:text-gray-500">Drop tasks here</span>
        </div>
      )}
      {tasks.map((task, idx) => (
        <Draggable draggableId={task.id} index={idx} key={task.id}>
          {(dragProvided: DraggableProvided, snapshot) => (
            <div
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              className={cn(
                "p-2 mb-2 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-md shadow-sm cursor-move",
                snapshot.isDragging ? "ring-2 ring-blue-500 bg-blue-50 dark:bg-blue-900/60" : ""
              )}
            >
              <div className="text-xs font-medium text-gray-900 dark:text-white">{task.title}</div>
            </div>
          )}
        </Draggable>
      ))}
      {provided.placeholder}
    </div>
  </div>
);

export default EisenhowerQuadrantColumn;
